/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetDetailZoneResponseDto
 */
export interface AssetDetailZoneResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetDetailZoneResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDetailZoneResponseDto
     */
    name: string;
}

/**
 * Check if a given object implements the AssetDetailZoneResponseDto interface.
 */
export function instanceOfAssetDetailZoneResponseDto(value: object): value is AssetDetailZoneResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function AssetDetailZoneResponseDtoFromJSON(json: any): AssetDetailZoneResponseDto {
    return AssetDetailZoneResponseDtoFromJSONTyped(json, false);
}

export function AssetDetailZoneResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetDetailZoneResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function AssetDetailZoneResponseDtoToJSON(json: any): AssetDetailZoneResponseDto {
    return AssetDetailZoneResponseDtoToJSONTyped(json, false);
}

export function AssetDetailZoneResponseDtoToJSONTyped(value?: AssetDetailZoneResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

